<template>
  <div>
    <div class="voucher-ios-box">
      <p class="voucher-ios-txt">구매 진행 시 <a href="#" @click="openAgreement('service')">서비스이용약관</a>과 <a href="#" @click="openAgreement('privacy')">개인정보 처리방침</a>을 확인해주세요.</p>
      <p class="voucher-ios-txt">이용권 구매 후에 서비스 이용권한 확인이 안되신다면 <button @click="clickRestore" class="voucher-ios-btn">구매내역 복원</button>을 통해 권한을 다시 불러올 수 있습니다. 그래도 확인이 안되신다면 결제 내역을 다시 한번 확인해주세요.</p>
<!--      <button @click="clickRestore" class="voucher-ios-btn">구매내역 복원하기</button>-->
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 주의사항</h3>
        <ul>
          <li>Wavve 서비스는 국내 및 해외 서비스 대상 국가에서 이용하실 수 있습니다.</li>
          <li>이용권 및 개별 구매 영화는 국내에서 결제 가능하고, 결제 후 해외 서비스 대상국가에서 모바일/태블릿 앱으로 (ios/Android) 7일간 시청할 수 있습니다.</li>
          <li>일부 콘텐츠는 콘텐츠 제공사의 요청으로 해외 서비스 대상 국가에서도 이용이 불가합니다.</li>
          <li>해외 서비스 대상 국가에서는 다운로드를 제공하지 않습니다.</li>
          <li>해외 서비스 대상 국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀, 베트남, 라오스, 태국</li>
          <li>해외 서비스 대상 국가가 아닌 국가에서는 서비스 이용이 불가합니다.</li>
          <li>프리미엄 이용권은 동시에 4명, 스텐다드 이용권은 2명이 동시에 시청할 수 있습니다. 베이직 이용권은 1명만 시청할 수 있습니다.</li>
          <li>일부 콘텐츠는 콘텐츠 제공사의 요청으로 LIVE 및 VOD 서비스를 제공하지 않을 수 있습니다.</li>
          <li>일부 콘텐츠는 콘텐츠 제공사의 요청으로 FHD 화질을 제공하지 않을 수 있습니다.</li>
          <li>콘텐츠에 따라 다운로드를 제공하지 않을 수 있으며, 이용권에 따라 다운로드 횟수가 제한됩니다.</li>
          <li>TV 기기에서는 다운로드가 불가합니다.</li>
          <li>프리미엄 이용권은 일부 콘텐츠를 최고화질(4K UHD, Dolby, HDR)로 시청할 수 있습니다. 최고화질은 이용하는 기기의 사양, 네트워크 환경 등에 따라 변경될 수 있습니다.</li>
          <li>이용 기기 중 TV 는 Wavve앱이 설치가 되어 있거나 앱스토어에서 설치가 가능한 스마트TV 및 Android TV 기기이며, TV에서는 일부 채널은 LIVE서비스를 제공하지 않습니다. <a href="/customer/faq?keyword=실시간 채널">자세히보기</a></li>
          <li>LG 스마트 TV 이외의 TV에서는 콘텐츠제공사의 요청으로 LIVE 서비스를 제공하지 않습니다.</li>
          <li>구형 smart TV에서 DRM콘텐츠 재생이 종료됨에 따라 서비스가 제공되지 않을 수 있습니다. <a href="/customer/notice_view?filterType=all&noticeId=2900" target="_blank" rel="noopener noreferrer">자세히보기</a></li>
          <li>자사의 콘텐츠 보호 정책에 따라 높은 등급의 보안 인증을 (Microsoft Playready SL3000 이상 / Google Widevine L1 이상 / Apple FairPlay) 받지 않은 기기이거나 HDCP 2.2 이상이 아닌 기기로 UHD(4K) 재생 시 낮은 화질(FHD 이하)로 재생될 수 있습니다.</li>
        </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 권장사양</h3>
      <ul>
        <li>iOS 15 버전 이상</li>
      </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">이용권 구매 주의 사항</h3>
      <ul>
        <li>모든 이용권은 부가세(VAT)포함 가격입니다.</li>
        <li>상품 가격은 내부 정책으로 인해 변경 될 수 있습니다.</li>
        <li>통신사, 신용카드 정보 변경 및 잔액부족 시에는 결제실패로 자동결제가 해지될 수 있습니다.</li>
        <li>이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다. 자세한 사항은 <a href="https://www.wavve.com/customer/agreement?category=payment">'유료상품 이용약관'</a>  제10조를 참조하시기 바랍니다.</li>
        <li>12개월 이용권의 경우, 장기 이용에 대한 할인 혜택이 적용된 금액이므로 중도 해지 시에는 1개월 이용권 기준의 할인 미적용 정상가 기준으로 일할 계산하여 환불 금액이 정산되오니 유의 부탁드립니다.</li>
        <li>이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)</li>
        <li>이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브 <a :href="getInquiryUrl()">고객센터</a>에 연락해 주시기 바랍니다.</li>
      </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">App Store 결제 주의사항</h3>
      <ul>
        <li>App Store 결제는 iTunes 계정을 통해 원화로 진행됩니다.</li>
        <li>해외원화결제(DCC)로 추가 수수료가 발생할 수 있습니다. (애플 고객센터: 080-333-4000)</li>
        <li>App Store 결제는 1개월 단위로 이루어지므로 구매하신 날과 매월 동일한 날짜에 자동결제 됩니다.</li>
        <li>자동결제 예정일 전 (최대) 24시간 이내에는 자동결제를 해지해도 결제 예정일에 결제가 이루어집니다.</li>
        <li>결제 시 자동결제 예정일 전 (최대) 24시간 이내에 금액확인과 함께 결제됩니다.</li>
        <li>App Store 자동결제 예정일과 실제 Wavve이용권 구매일/만료일 표기는 결제 시점, 구매 오류 후 구매 복원일, 시차 차이 등으로 인하여 다를 수 있습니다.</li>
        <li>자동결제 해지 시 결제 예정일(최대 만료시간 24시간 전)을 제외한 이용기간 중 언제든지 자동결제를 해지하실 수 있습니다. 이 경우 더 이상 추가 결제되지 않으며 남은 기간 동안은 계속 이용하실 수 있습니다.</li>
        <li>App Store 자동결제는 iTunes의 [계정설정 > 구독관리]에서 해지하실 수 있습니다.</li>
      </ul>
      <div class="button-area">
        <button @click="openAgreement('service')">서비스 이용약관</button>
        <button @click="openAgreement('privacy')">개인정보 처리방침</button>
      </div>
      <portal to="agreement-popup" v-if="isOpenAgreement">
        <div class="info-popup-background"></div>
        <div class="info-popup-wrapper">
          <div class="info-popup-header">
            <span v-if="type === 'service'">서비스 이용약관</span>
            <span v-if="type === 'privacy'">개인정보 처리방침</span>
            <button class="btn-modal-close" @click="closeAgreement">
              <img src="/img/common/btn-close-white.png" alt="팝업 닫기">
            </button>
          </div>
          <div class="agreement-body" ref="agreement-body">
            <div class="policy-wrap" v-if="termsData !== null">
              <div class="policy-date">시행일자 {{termsData.effectivedate}}</div>
              <div class="policy-desc" v-html="termsData.content"></div>
              <div class="policy-btn">
                <ul>
                  <li v-if="termsData.prevversion !== ''" class="pre-policy">
                    <a @click.prevent="getAgreementVersion(termsData.prevversion)" href="#">
                      <img src="/img/common/arrow-title-prev.png" alt=""/>
                      <span>이전 약관 보기</span>
                    </a>
                  </li>
                  <li v-if="termsData.version !== 'last'" class="now-policy">
                    <a @click.prevent="getAgreementVersion('last')" href="#">
                      <span>현재 약관 보기</span>
                      <img src="/img/common/arrow-title-next.png" alt=""/></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </div>
  </div>
</template>

<script>
import { AgreementService } from '@/common/api/api.service'
import { isApp } from '@/common/util/common'

export default {
  data () {
    return {
      isOpenAgreement: false,
      type: '',
      termsData: null,
      version: 'last'
    }
  },
  methods: {
    // 구매내역 복원하기
    clickRestore () {
      try {
        window.webkit.messageHandlers.clickRestore.postMessage('clickRestore')
      } catch (err) {
        console.log(err)
      }
    },
    openAgreement (type) {
      this.type = type
      this.getAgreementVersion(this.version)
      // this.isOpenAgreement = true
    },
    closeAgreement () {
      this.version = 'last'
      this.isOpenAgreement = false
    },
    getAgreementVersion (termVersion) {
      this.version = termVersion
      this.setAgreementData()
    },
    setAgreementData () {
      AgreementService.getTerms({
        type: this.type,
        version: this.version
      }).then(({ data }) => {
        this.termsData = data
        this.isOpenAgreement = true
        this.$nextTick(() => {
          this.$refs['agreement-body'].scrollTo(0, 0)
        })
      })
    },
    getInquiryUrl () {
      return isApp() ? 'captvpooq://customer/qna/inquiry' : 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
    }
  }
}
</script>
<style scoped>
  .button-area{
    margin-top: 20px;
    font-size: 0;
  }
  .button-area button{
    display: inline-block;
    width: 47.5%;
    height: 32px;
    border: 1px #1351f9 solid;
    border-radius: 44px;
    background-color: #1351f9;
    font-size: 14px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
  }
  .button-area button + button{
    margin-left: 5%;
  }
  .info-popup-wrapper {
    display: table;
    position: fixed;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5000;
    width: 90%;
    height: 66%;
    background-color: #252525;
  }
  .info-popup-background {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4000;
  }
  .info-popup-header {
    position: relative;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: #fff;
    text-align: center;
  }
  .btn-modal-close{
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
  }
  .btn-modal-close img{
    width: 100%;
  }
  /*.vue-friendly-iframe {*/
  /*  position: relative;*/
  /*  margin: 0 auto;*/
  /*  height: 70%;*/
  /*  width: 100%;*/
  /*}*/
  /*.vue-friendly-iframe iframe {*/
  /*  width: 100% !important;*/
  /*  height: 100% !important;*/
  /*}*/
  .agreement-body{
    position: relative;
    min-height: 56px;
    height: calc(100% - 80px);
    margin: 20px 0;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    word-break: break-all;
  }
  .agreement-body::-webkit-scrollbar{
    display: none
  }
  .policy-date{
    padding: 0 15px;
    height: 44px;
    line-height: 44px;
    font-size: 12px;
    color: #a5a5a5;
    border-bottom: 1px solid #2f2f2f;
  }
  .policy-desc {
    font-size: 13px;
    line-height: 22px;
    color: #a5a5a5;
    padding: 15px 15px 50px;
  }
  .policy-wrap {
    width: 100%;
    padding-bottom: 30px;
  }
  .policy-wrap::-webkit-scrollbar{
    display: none;
    background-color: transparent;
  }
  .policy-btn {
    padding-left: 10px;
  }
  .policy-btn a {
    display: block;
    width: 100%;
    height: 30px;
    padding: 0 12px;
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    font-size: 0;
    line-height: 28px;
    text-align: center;
    color: #fff;
  }
  .policy-btn a img,
  .policy-btn a span{
    display: inline-block;
    font-size: 12px;
    vertical-align: middle;
  }
  .policy-btn a img{
    width: 12px;
    height: 12px;
  }
  .policy-btn a img + span,
  .policy-btn a span + img{
    margin-left: 3px;
  }
  .policy-btn ul::after{
    content: '';
    display: table;
    clear: both;
  }
  .policy-btn li {
    float: left;
    text-align: center;
  }
</style>
